import * as THREE from "three";
const CENTER = new THREE.Vector3(0, 0, 0);

export default (scene: any) => {
	// -light
	const ambientLight = new THREE.AmbientLight("white", 0.1);
	scene.add(ambientLight);

	const pointLight = new THREE.PointLight("white", 1.2);
	pointLight.position.set(1000, 1200, 2000);
	pointLight.lookAt(CENTER);
	scene.add(pointLight);

	const backLight = new THREE.PointLight(`#0dfffb`, 0.5);
	backLight.position.set(-100, 0, 0);
	backLight.lookAt(CENTER);
	scene.add(backLight);
};

export const listLight = (scene: any, radius: number) => {
	// -light
	const ambientLight = new THREE.AmbientLight("white", 0.01);
	scene.add(ambientLight);

	const pointLight = new THREE.PointLight("white", 2);
	pointLight.position.set(radius * 2, radius * 2, radius * 2);
	const pointLightHelper = new THREE.PointLightHelper(pointLight);

	scene.add(pointLight);
	scene.add(pointLightHelper);

	const backLight = new THREE.SpotLight(`#0dfffb`, 1);
	backLight.position.set(radius * -2, 0, radius * -1);
	scene.add(backLight);
};
